import { Button, Dropdown, Icon } from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import { TContactActions } from "./types"


export function ContactActions({ contact, onOpen, onUnsubscribe, onAddToSuppressionList, onDelete }: TContactActions) {
    const { t } = useTranslation()

    function handleOpen() {
        onOpen(contact)
    }
    function handleUnsubscribe() {
        onUnsubscribe(contact)
    }
    function handleAddToSuppressionList() {
        onAddToSuppressionList(contact)
    }
    function handleDelete() {
        onDelete(contact)
    }

    return <Stack direction="row" gap={3}>
        <Button
            onClick={handleOpen}
            size="small"
            color="body1"
            variant="outlined"
        >{t("general-open_one")}</Button>
        <Dropdown
            size="medium"
            color="body1"
            variant="outlined"
            iconOnly
            defaultValue={""}
            options={[
                {
                    isAction: true,
                    text: t("general-unsubscribe_other"),
                    postContent: <Icon name="Unsubscribes24" sx={{ width: 18, height: 18 }} />,
                    onClick: handleUnsubscribe
                },
                {
                    isAction: true,
                    text: t("general-add-to-suppression-list"),
                    postContent: <Icon name="Domainblocked18" />,
                    onClick: handleAddToSuppressionList
                },
                {
                    isAction: true,
                    text: t("general-delete"),
                    postContent: <Icon name="Delete18" />,
                    onClick: handleDelete
                }
            ]}
        />
    </Stack>
}